import React from "react";
import { Outlet } from "react-router-dom";
import clsx from "clsx";

import { View, Button } from "../components/base";
import { Icon } from "../components/base/Icon";
import { RequireAuth } from "../components/auth/RequireAuth";
import { LeftNavbar, SidebarSection } from "../components/LeftNavbar";
import { useAuth } from "../hooks/useAuth";
import { CommandPaletteProvider, CommandPalette } from "../components/CommandPalette";

export const AdminLayout = () => {
  const { isAdmin } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = React.useState(() => {
    const saved = localStorage.getItem("sidebarCollapsed");
    return saved !== null ? JSON.parse(saved) : false;
  });

  // Save to localStorage whenever collapsed state changes
  React.useEffect(() => {
    localStorage.setItem("sidebarCollapsed", JSON.stringify(isSidebarCollapsed));
  }, [isSidebarCollapsed]);

  const adminSections: SidebarSection[] = [
    {
      title: "Admin",
      links: [
        { label: "Users", to: "/admin/users" },
        { label: "Organizations", to: "/admin/organizations" },
        { label: "Training jobs", to: "/admin/trainingJobs" },
      ],
    },
    {
      title: "Platform",
      links: [
        { label: "Agents", to: "/agents" },
        { label: "Evaluators", to: "/evaluators" },
        { label: "Simulations", to: "/agents/simulations" },
        { label: "Recipes", to: "/agents/recipes" },
        { label: "Resources", to: "/resources" },
      ],
    },
  ];

  return (
    <CommandPaletteProvider>
      <RequireAuth requireAdmin>
        <View className="flex h-screen bg-gray-50 dark:bg-black">
          <LeftNavbar
            sections={adminSections}
            isOpen={isMobileMenuOpen}
            onClose={() => setIsMobileMenuOpen(false)}
            isCollapsed={isSidebarCollapsed}
            onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
          />
          <View className={clsx("flex flex-col flex-1 overflow-hidden mr-3", isSidebarCollapsed ? "lg:ml-[60px]" : "lg:ml-[220px]")}>
            {/* Mobile hamburger button */}
            <Button
              type="button"
              variant="ghost"
              onClick={() => setIsMobileMenuOpen(true)}
              className="hamburger-button lg:hidden absolute top-4 left-4 z-40 !h-10 !w-10 rounded-md bg-white dark:bg-[#0a0a0a] border border-gray-200 dark:border-[#1a1a1a] hover:bg-gray-100 dark:hover:bg-[#0a0a0a]/80 transition-colors flex items-center justify-center shadow-md"
            >
              <Icon
                name="menu"
                size={20}
                className="text-gray-600 dark:text-[#666]"
              />
            </Button>
            <View className="flex flex-1 overflow-y-auto bg-gray-50 dark:bg-black">
              <Outlet />
            </View>
          </View>
        </View>
      </RequireAuth>
      <CommandPalette />
    </CommandPaletteProvider>
  );
};
